import { useLayoutEffect, useState } from "react";
import { PositionState } from "../types";

export const POPOVER_W = 320;
export const POPOVER_EST_H = 480;

export const usePopoverPosition = (
  anchorEl: HTMLElement | null,
  open: boolean,
  alwaysVisible: boolean,
): PositionState => {
  const [position, setPosition] = useState<PositionState>({
    top: 0,
    bottom: "auto",
    left: 0,
    maxHeight: "100%",
  });

  useLayoutEffect(() => {
    if (!open || alwaysVisible || !anchorEl) return;

    const rect = anchorEl.getBoundingClientRect();

    // Default: Below
    let top: number | "auto" = rect.bottom + 8;
    let bottom: number | "auto" = "auto";
    let left = rect.left;

    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    // Flip logic
    if (spaceBelow < POPOVER_EST_H && spaceAbove > spaceBelow) {
      top = "auto";
      bottom = window.innerHeight - rect.top + 8;
    }

    // Horizontal logic
    if (left + POPOVER_W > window.innerWidth) {
      left = Math.max(8, window.innerWidth - POPOVER_W - 8);
    }

    // Max Height logic
    const maxHeight =
      top !== "auto" ? window.innerHeight - top - 16 : rect.top - 16;

    setPosition({ top, bottom, left, maxHeight });
  }, [anchorEl, open, alwaysVisible]);

  if (alwaysVisible) {
    return { top: 0, bottom: 0, left: 0, maxHeight: "100%" };
  }

  return position;
};
